<template>
  <div>
    <!-- Floating Comment Section -->
    <div class="floating-bottom-right">
      <transition name="from-bottom">
        <edit-loan-comments
          v-model="application"
          v-if="comment_section_vissible"
          :available-sections="availableSections"
          :current-sections="currentSections"
          @save_application="(resolve, reject) => saveApplication().then(resolve).catch(reject)"
        />
      </transition>

      <md-dialog-alert
        :md-active.sync="error_dialog.show"
        :md-title="error_dialog.title"
        :md-content="error_dialog.content"
      />
    </div>
    <!-- FAB button row -->
    <div class="button-container">
      <!-- Comment -->
      <md-button
        class="md-icon-button md-raised md-just-icon fab"
        :class="{
          'pink': !comment_section_vissible,
          'red':   comment_section_vissible,
        }"
        @click="comment_section_vissible = !comment_section_vissible"
      >
        <md-icon v-if="comment_section_vissible">close</md-icon>
        <md-icon v-else>comment</md-icon>
        <md-tooltip md-direction="left">Add comments</md-tooltip>
      </md-button>
      <md-chip
        :class="{
          'pink': !comment_section_vissible,
          'red':   comment_section_vissible,
        }">
        Notes
      </md-chip>
    </div>
  </div>
</template>

<script>
import transitions from "@/components/utils/transitions";
import EditLoanComments from '@/components/Editors/EditLoanComments';
export default {
  components: {
    EditLoanComments,
  },
  data() {
    return {
      comment_section_vissible: false,
      transitions,
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    availableSections: {
      type: Array,
      default: [],
    },
    currentSections: {
      type: String,
      default: '',
    },
  },
  computed: {
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get(){ return this.value },
      set(application){ this.$emit('input', application) },
    },
  },
  methods: {
    async saveApplication() {
      if (this.application && this.application.loan && this.application.loan.id) {
        try {
          await this.$store.dispatch("save_application", this.application);
        } catch (e) {
          this.error_dialog.title = "Error saving application";
          this.error_dialog.content = `Error Message: ${e.response.data}`;
          this.error_dialog.show = true;
          throw e;
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.pink {
  background-color: #c51162 !important;
}
.red {
  background-color: #d9534f !important;
}
.floating-bottom-right {
  position: absolute;
  top: 55%;
  right: 30px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  transform: translateY(-100%);
}

.button-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 55%;
  right: 30px;
}

.fab {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.md-chip {
    font-size: 14px;
    height: 25px !important;
    width: 60px !important;
    font-weight: bold !important;
    padding-top: 3px !important;
    text-align: center;
    color: white !important;
    z-index: 3;
}
.fab .md-icon {
  font-size: 27px !important;
}
</style>
